import server from "./server";

export const getPageDataApi = async ({ cookies, slug }) => {
  const response = await server({ cookies }).get(`/pages/${slug}`);
  return response.data;
};

export const getSectionDataApi = async ({ cookies, pageSlug, sectionSlug }) => {
  const response = await server({ cookies }).get(
    `/pages/${pageSlug}/sections/${sectionSlug}`,
  );
  return response.data;
};

export const getSettingsApi = async ({ cookies }) => {
  const response = await server({ cookies }).get("/settings/siteInfo");
  return response.data;
};

export const contactUsApi = async ({ cookies, data }) => {
  const response = await server({ cookies }).post("/contactUs", data);
  return response.data;
};

export const getServicesApi = async ({ cookies }) => {
  const response = await server({ cookies }).get(`/pages/services`);
  return response.data;
};

export const getProjectsApi = async ({ cookies }) => {
  const response = await server({ cookies }).get(`/pages/works`);
  return response.data;
};

export const getProjectTypesApi = async ({ cookies }) => {
  const response = await server({ cookies }).get(`/pages/projects-Types`);
  return response.data;
};

export const getBlogsApi = async ({ cookies, page }) => {
  const response = await server({ cookies }).get(`/blogs?page=${page}`);
  return response.data;
};

export const getSingleBlogApi = async ({ cookies, slug }) => {
  const response = await server({ cookies }).get(
    `/blogs/getBlogBySlug/${encodeURIComponent(slug)}`,
  );
  return response.data;
};

export const getBlogCategoriesApi = async ({ cookies }) => {
  const response = await server({ cookies }).get(`/categories`);
  return response.data;
};

export const getSingleCategoryApi = async ({ cookies, slug }) => {
  const response = await server({ cookies }).get(
    `/categories/byslug/${encodeURIComponent(slug)}`,
  );
  return response.data;
};

export const getBlogsByCategoryApi = async ({ cookies, slug }) => {
  const response = await server({ cookies }).get(
    `/blogs/getBlogsByCategorySlug/${encodeURIComponent(slug)}`,
  );
  return response.data;
};

export const subscribeNewsletterApi = async ({ cookies, data }) => {
  const response = await server({ cookies }).post("/subscribers", data);
  return response.data;
};

export const getSocialsApi = async ({ cookies }) => {
  const response = await server({ cookies }).get("/pages/socialLinks");
  return response.data;
};

export const getClientsApi = async ({ cookies }) => {
  const response = await server({ cookies }).get(
    "/pages/home/sections/clients",
  );
  return response.data;
};

export const getContactSectionApi = async ({ cookies }) => {
  const response = await server({ cookies }).get(
    "/pages/home/sections/contact",
  );
  return response.data;
};
